"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEndShift = exports.CreateCashCount = exports.acceptableDenominations = void 0;
const mobx_1 = require("mobx");
exports.acceptableDenominations = [1, 5, 10, 25, 100, 200, 500, 1000, 2000, 5000, 10000];
class CreateCashCount {
    constructor() {
        this.setCashCount = (state) => {
            this.cashCount = state === 'default' ? this.defaultCashCount : null;
        };
        this.setCashCountItem = (denominator, count) => {
            if (this.cashCount === null || isNaN(denominator)) {
                return;
            }
            this.cashCount[denominator] = count;
        };
        this.cashCount = this.defaultCashCount;
    }
    get isCashCountFilled() {
        const thisCashCount = this.cashCount;
        if (thisCashCount === null) {
            return false;
        }
        return exports.acceptableDenominations.some((deno) => thisCashCount[deno] !== null);
    }
    get defaultCashCount() {
        const defaultCashCount = {};
        exports.acceptableDenominations.forEach((deno) => {
            defaultCashCount[deno] = null;
        });
        return defaultCashCount;
    }
    get totalCashCount() {
        let total = 0;
        if (this.cashCount === null) {
            return total;
        }
        else {
            exports.acceptableDenominations.forEach((deno) => {
                const count = this.cashCount[deno] || 0;
                total += deno * count;
            });
        }
        return total;
    }
}
exports.CreateCashCount = CreateCashCount;
__decorate([
    mobx_1.observable
], CreateCashCount.prototype, "cashCount", void 0);
__decorate([
    mobx_1.action
], CreateCashCount.prototype, "setCashCount", void 0);
__decorate([
    mobx_1.action
], CreateCashCount.prototype, "setCashCountItem", void 0);
__decorate([
    mobx_1.computed
], CreateCashCount.prototype, "isCashCountFilled", null);
__decorate([
    mobx_1.computed
], CreateCashCount.prototype, "defaultCashCount", null);
__decorate([
    mobx_1.computed
], CreateCashCount.prototype, "totalCashCount", null);
class CreateEndShift extends CreateCashCount {
    constructor() {
        super();
        this.registerPasscode = '';
        this.setRegisterPasscode = (registerPasscode) => {
            this.registerPasscode = registerPasscode;
        };
    }
}
exports.CreateEndShift = CreateEndShift;
__decorate([
    mobx_1.observable
], CreateEndShift.prototype, "registerPasscode", void 0);
__decorate([
    mobx_1.action
], CreateEndShift.prototype, "setRegisterPasscode", void 0);
//# sourceMappingURL=models.js.map